<template>
  <div>
    <v-container>
      <h3 class="d-block text-center" style="color: #434343; padding: 8px">
        Primary Contact Details
      </h3>
      <v-form ref="formPrimaryContact">
        <v-row class="ma-0">
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Contact Name
              <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="primary_contact_details.contact_name"
              color="#434343"
              outlined
              placeholder="Enter Contact Name"
              maxlength="51"
              label=""
              dense
              name="primary_contact_number"
              id="primary_contact_number"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Contact Number
              <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="TextRules"
              v-model="primary_contact_details.phone_no"
              color="#434343"
              outlined
              placeholder="Enter Contact Number"
              maxlength="51"
              label=""
              dense
              name="primary_contact_number"
              id="primary_contact_number"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label
              >Email <span class="red--text"><strong>* </strong></span></label
            >

            <v-text-field
              :rules="[emailRules]"
              v-model="primary_contact_details.email"
              color="#434343"
              outlined
              placeholder="Enter Email"
              maxlength="51"
              label=""
              dense
              name="primary_contact_email"
              id="primary_contact_email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Position
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="primary_contact_details.position"
              color="#434343"
              outlined
              placeholder="Enter Position"
              maxlength="51"
              label=""
              dense
              name="primary_contact_position"
              id="primary_contact_position"
            ></v-text-field>
          </v-col>
        </v-row>

        <h3 class="text-center my-3" style="color: #434343">
          Primary Financial/Reporting Details
        </h3>
        <v-row class="ma-0">
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Contact Name
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="financial_contact_details.contact_name"
              color="#434343"
              outlined
              placeholder="Enter Contact Name "
              maxlength="51"
              label=""
              dense
              name="financial_contact_name"
              id="financial_contact_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Contact Number
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="financial_contact_details.phone_no"
              color="#434343"
              outlined
              placeholder="Enter Contact Number"
              maxlength="51"
              label=""
              dense
              name="financial_contact_number"
              id="financial_contact_number"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Email <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="[emailRules]"
              v-model="financial_contact_details.email"
              color="#434343"
              outlined
              placeholder="Enter Email"
              maxlength="51"
              label=""
              dense
              name="financial_contact_email"
              id="financial_contact_email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Position
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="financial_contact_details.position"
              color="#434343"
              outlined
              placeholder="Enter Position"
              maxlength="51"
              label=""
              dense
              name="financial_contact_position"
              id="financial_contact_position"
            ></v-text-field>
          </v-col>
        </v-row>

        <h3 class="text-center my-3" style="color: #434343">
          Primary IT/Tech Details
        </h3>
        <v-row class="ma-0">
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Contact Name
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="technical_contact_details.contact_name"
              color="#434343"
              outlined
              placeholder="Enter Contact Name"
              maxlength="51"
              label=""
              dense
              name="technical_contact_name"
              id="technical_contact_name"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Contact Number
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="technical_contact_details.phone_no"
              color="#434343"
              outlined
              placeholder="Enter Contact Number"
              maxlength="51"
              label=""
              dense
              name="technical_contact_number"
              id="technical_contact_number"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Email <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="[emailRules]"
              v-model="technical_contact_details.email"
              color="#434343"
              outlined
              placeholder="Enter Email"
              maxlength="51"
              label=""
              dense
              name="technical_contact_email"
              id="technical_contact_email"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <span class="red--text"><strong>* </strong></span> -->
            <label for=""
              >Position
              <span class="red--text"><strong>* </strong></span></label
            >
            <v-text-field
              :rules="TextRules"
              v-model="technical_contact_details.position"
              color="#434343"
              outlined
              placeholder="Enter Position"
              maxlength="51"
              label=""
              dense
              name="technical_contact_position"
              id="technical_contact_position"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-btn
              @click="updatePrimaryContactDetailsSection()"
              class="float-end mb-2 next-btn appBlue white--black ml-2"
              >Next</v-btn
            >
            <v-btn
              text
             @click="updateIndex(1)"
              class="mb-2 float-end mx-1 adjust-pre-btn next-btn liteGray black--text"
              >Previous</v-btn
            >
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      primary_contact_details: {
        contact_name: "",
        phone_no: "",
        email: "",
        position: "",
      },
      TextRules: [(v) => !!v || "Required"],
      // emailRules: [
      //   (v) => !!v || "Email is required",
      //   (v) => /[A-Za-z0-9_]+@[a-z0-9.-]+\.[a-zA-Z]{2,}/.test(v) || "E-mail must be valid",
      // ],
      emailRules: (v) =>
      /[A-Za-z0-9_]+@[a-z0-9.-]+\.[a-zA-Z]{2,}/.test(v) ||
      "E-mail must be valid",
      financial_contact_details: {
        contact_name: "",
        phone_no: "",
        email: "",
        position: "",
      },
      technical_contact_details: {
        contact_name: "",
        phone_no: "",
        email: "",
        position: ""
      },
    };
  },
   computed: {
    ...mapGetters([
      "getFormId",
      "getUserId",
      "getCorporateID",
      "getPrimaryID",
      "getTechnicalID",
      "getFinancialID"
    ])
  },
  mounted(){
     this.getContactInfo();
  },
  methods:{
      getContactInfo(){
         axios
      .post(
        "/contactDetailsForm",
        {
          form_id: this.getFormId,
          user_id: this.getUserId
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        // console.log(res.data, "contact details");
        this.primary_contact_details.contact_name =
          res.data.primaryContactDetail.contact_name == null
            ? ""
            : res.data.primaryContactDetail.contact_name;
        this.primary_contact_details.phone_no =
          res.data.primaryContactDetail.phone_no == null
            ? ""
            : res.data.primaryContactDetail.phone_no;
        this.primary_contact_details.email =
          res.data.primaryContactDetail.email == null
            ? ""
            : res.data.primaryContactDetail.email;
        this.primary_contact_details.position =
          res.data.primaryContactDetail.position == null
            ? ""
            : res.data.primaryContactDetail.position;

        this.financial_contact_details.contact_name =
          res.data.financialContactDetail.contact_name == null
            ? ""
            : res.data.financialContactDetail.contact_name;
        this.financial_contact_details.phone_no =
          res.data.financialContactDetail.phone_no == null
            ? ""
            : res.data.financialContactDetail.phone_no;
        this.financial_contact_details.email =
          res.data.financialContactDetail.email == null
            ? ""
            : res.data.financialContactDetail.email;
        this.financial_contact_details.position =
          res.data.financialContactDetail.position == null
            ? ""
            : res.data.financialContactDetail.position;

        this.technical_contact_details.contact_name =
          res.data.technicalContactDetail.contact_name == null
            ? ""
            : res.data.technicalContactDetail.contact_name;
        this.technical_contact_details.phone_no =
          res.data.technicalContactDetail.phone_no == null
            ? ""
            : res.data.technicalContactDetail.phone_no;
        this.technical_contact_details.email =
          res.data.technicalContactDetail.email == null
            ? ""
            : res.data.technicalContactDetail.email;
        this.technical_contact_details.position =
          res.data.technicalContactDetail.position == null
            ? ""
            : res.data.technicalContactDetail.position;
      })
      .catch(err => {
        console.log(err.response, "err");
      });

      },
          // update primary contact details
    updatePrimaryContactDetailsSection() {
      // this.corporateStepper=2;
      // this is validating fields of primary contact stepper
      if (!this.$refs.formPrimaryContact.validate()) {
        this.$store.dispatch("updateContactDetailsError", true);
        this.primaryContactError = !true;
      } else {
        this.$store.dispatch("updateContactDetailsError", !true);
        this.primaryContactError = true;
      }
      axios
        .post(
          "/createContactDetails",
          {
            form_id: this.getFormId,
            user_id: this.getUserId,
            primary_contact_detail_id: this.getPrimaryID,
            financial_contact_detail_id: this.getFinancialID,
            technical_contact_detail_id: this.getTechnicalID,
            primary_contact_detail: this.primary_contact_details,
            financial_contact_detail: this.financial_contact_details,
            technical_contact_detail: this.technical_contact_details
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          // console.log(res.data, "contact details");
        })
        .catch(err => {
          console.log(err.response);
        });
      this.corporateStepper = 3;
      this.updateIndex(3);
    },
     updateIndex(index) {
        this.$store.dispatch("updateIndex", index);
    },
    
  }
};
</script>

<style>
</style>